import React from "react";
import Marquee from "react-fast-marquee";
import { TECH_MARQUEE } from "@/lib/site-data";

export default function TechMarquee({ theme = "light" }) {
  const isDark = theme === "dark";
  return (
    <div
      data-testid="tech-marquee"
      className={`py-10 border-y ${
        isDark ? "bg-slate-950 border-slate-800" : "bg-slate-50 border-slate-200"
      }`}
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {TECH_MARQUEE.map((item, i) => (
          <div
            key={i}
            className={`flex items-center gap-4 px-8 font-mono text-sm tracking-[0.25em] ${
              isDark ? "text-slate-500" : "text-slate-400"
            }`}
          >
            <span>{item}</span>
            <span className={`w-1 h-1 ${isDark ? "bg-slate-700" : "bg-slate-300"}`} />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
